/* eslint-disabled */

export default class SuggestionExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
